<template>
    <v-card class="mb-6 mr-4">
        <v-card-title>
            <div v-if="with_name" class="mr-4">{{ group.name }}</div>
            <template v-if="edited">
                <v-dialog v-model="dialog" persistent width="80vw">
                    <!-- Кнопка вызова диалогового окна -->
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="warning" dark v-bind="attrs" v-on="on">Добавить продукт</v-btn>
                    </template>
                    <!-- Форма создания комплектубщей -->
                    <v-card>

                        <v-card-title>
                            <span class="headline">Создание продукта</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="6" sm="12" md="6" xs="12">
                                        <v-text-field label="Название продукта*" required v-model="name"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="12" md="6" xs="12">
                                        <v-text-field label="Коэфициент ДПФ" value="10.00" prefix="₽" v-model="ratio"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="12" md="6">
                                        <v-file-input show-size counter label="Изображение" v-model="image"></v-file-input>
                                    </v-col>
                                    <v-col cols="6" sm="12" md="6">
                                        <v-select :items="get_sub_groups" label="Подгруппа" v-model="sub_group" item-text="name" item-value="name"></v-select>
                                    </v-col>
                                </v-row>
                                <v-spacer></v-spacer>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-row class="mt-6">
                                            <v-col cols="6">
                                                <h2>Состав:</h2>
                                            </v-col>
                                            <v-col cols="6 text-right">
                                                <v-dialog v-model="accessories_dialog" persistent width="80vw">
                                                    <!-- Кнопка вызова диалогового окна -->
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn color="warning" dark v-bind="attrs" v-on="on">Добавить</v-btn>
                                                    </template>
                                                    <!-- Форма создания комплектубщей -->
                                                    <v-card>

                                                        <v-card-title>
                                                            <span class="headline">Укажите деталь</span>
                                                        </v-card-title>

                                                        <v-card-text>
                                                            <v-container>
                                                                <v-row>
                                                                    <v-card
                                                                        class="mb-6 mr-4"
                                                                        max-width="344"
                                                                        v-for="accessory in get_accessories"
                                                                        :key="accessory._id"
                                                                        @click="add_accessory(accessory)"
                                                                    >
                                                                        <v-img :src="`/images/accessories/${accessory.image}`" height="200px"></v-img>
                                                                        <v-card-title>{{ accessory.name }}</v-card-title>
                                                                    </v-card>
                                                                </v-row>
                                                            </v-container>
                                                        </v-card-text>

                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="blue darken-1" text @click="accessories_dialog = false">Закрыть</v-btn>
                                                            <v-btn color="warning" dark @click="save()">Выбрать</v-btn>
                                                        </v-card-actions>

                                                    </v-card>
                                                </v-dialog>
                                            </v-col>
                                        </v-row>
                                        <v-row class="d-flex justify-space-around">
                                            <div class="accessory" v-for="accessory in accessories" :key="accessory._id">
                                                <img :src="`/images/accessories/${accessory.image}`" />
                                                <span class="text">x</span>
                                                <input type="number" v-model="accessory.quantity" />
                                            </div>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialog = false">Закрыть</v-btn>
                            <v-btn color="warning" dark @click="save()">Сохранить</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
        </v-card-title>
          
        <div class="products-grid">
            <Product
                v-for="product in group.products"
                :key="product._id"
                :item="product"
                type="products"
                :plan="plan"
                :group_id="group._id"
                :fact="fact"
                :small="small"
                :_id="_id"
                :status="status"
                :input="input"
                :brigade_count_users="brigade_count_users"
                :brigade_selected="brigade_selected"
            />
        </div>
    </v-card>
</template>
<script>
import axios from "axios";
import Product from "@/components/products/Product.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "ProductGroup",
    props: ["group", "with_name", "edited", "plan", "fact", "small", "_id", 'status', 'input', 'brigade_count_users',
    'brigade_selected'],
    data: () => ({
        dialog: false,
        accessories_dialog: false,
        name: null,
        image: null,
        sub_group: null,
        ratio: 10,
        accessories: [],
        items: [
            {
                name: "1 подгруппа",
                value : 'А'
            },
            {
                name: "2 подгруппа",
                value : 'Б'
            },
            {
                name: "3 подгруппа",
                value : 'В'
            },
            {
               name: "4 подгруппа",
                value : 'Г'
            },
            {
               name: "5 подгруппа",
                value : 'Д'
            },
            {
                name: "6 подгруппа",
                value : 'Е'
            },
            {
                name: "7 подгруппа",
                value : 'Ж'
            },
            {
                name: "8 подгруппа",
                value : 'З'
            },
            {
                name: "9 подгруппа",
                value : 'И'
            },
            {
                name: "10 подгруппа",
                value : 'К'
            }
        ]
    }),
    components: {
        Product,
    },
    computed: {
        ...mapGetters(["get_accessories", "get_original_products", "get_baseURL", 'get_sub_groups']),
    },
    methods: {
        ...mapActions(["create_product", "add_image"]),
        save() {
            if (!this.name || !this.image) return false;
            this.upload_image();
        },
        async upload_image() {
            let formData = new FormData();
            formData.append("file", this.image);

            const instance = await axios.create({
                baseURL: this.get_baseURL,
                headers: {
                "Content-Type": "multipart/form-data",
                Authorization: localStorage.getItem("_token"),
                },
            });
            console.log(777)
            instance
                .post(`/original_products/image`, formData)
                .then((response) => response.data)
                .then((data) => {
                    this.create_product({
                        name: this.name,
                        image: data.name,
                        ratio: this.ratio,
                        accessories: this.accessories,
                        group_id: this.group._id,
                        sub_group: this.sub_group
                    });
                    this.name = null;
                    this.image = null;
                    this.ratio = null;
                    this.accessories = [];
                    this.dialog = false;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {});
        },

        add_accessory(accessory) {
            this.accessories.push(accessory);
            this.accessories_dialog = false;
        },
    },
};
</script>

<style scoped>
.accessory {
  display: flex;
  align-items: center;
}

.accessory img {
  object-fit: contain;
  max-height: 200px;
  max-width: 200px;
}

.accessory text {
  font-size: 40px;
  margin: 0 20px;
}

.accessory input {
  font-size: 52px;
  max-width: 70px;
  padding: 0px 5px 0 20px;
  border-bottom: 1px solid;
}
</style>